export default __webpack_public_path__ + "static/media/10_photo.faf2286e.jpg";